module.exports = __webpack_public_path__ + "static/img/dna_weaver_logo.c03c805.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dna_weaver_logo.svg
// module id = rU0t
// module chunks = 1